import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardMedia, Typography, CardContent } from '@mui/material';
import { getEntityImageUrl } from '../../../../api/utils'
import { AvatarContainer } from './styled';
import noAvatar from '../../../../assets/images/no-avatar.png'

const EventListItem = ({ event, selectEvent }) => {

  const handleImageRenderError = (e) => {
    e.target.src = noAvatar
  }

  const eventDateStr = () => { 
    const date = new Date(event?.start)
    return date.toLocaleDateString()
  }

  return (
    <div onClick={() => selectEvent(event)} style={{ cursor: 'pointer', position: 'relative' }}>
      <Card style={{ position: 'relative' }}>
        <AvatarContainer>
          <CardMedia
            component="img"
            src={getEntityImageUrl(event, noAvatar)}
            alt="Event Image"
            onError={handleImageRenderError}
            sx={{ borderRadius: '10px' }}
          />
        </AvatarContainer>
        <CardContent>
          
            <Typography sx={{ marginTop: '4px', paddingLeft: '6px', fontSize: '16px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {event?.name}
            </Typography>
            <Typography sx={{ marginTop: '4px', paddingLeft: '6px', fontSize: '16px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {eventDateStr()}
            </Typography>
          

        </CardContent>

      </Card>
    </div>
  );
};

EventListItem.propTypes = {
  event: PropTypes.object,
  selectEvent: PropTypes.func,
}

export default EventListItem
